import { RouteComponent, RouteRecordRaw } from 'vue-router';
import { DASHBOARD_SECTIONS_ROUTES } from '@/models/common/permissions.model';
import { DASHBOARD_META_TITLES } from '@/models/common/meta-titles.model';

export const documentsRoutes: RouteRecordRaw[] = [
  {
    name: DASHBOARD_SECTIONS_ROUTES.DOCUMENTS,
    path: DASHBOARD_SECTIONS_ROUTES.DOCUMENTS,
    meta: { title: DASHBOARD_META_TITLES.DOCUMENTS_PAGE },
    component: async (): Promise<RouteComponent> =>
      await import('@/layouts/documents-page/documents-page.vue'),
  },
];
